module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "campusIdManage"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("个性化组件")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_vm._v("\n    类型：\n    "), _c('el-select', {
    on: {
      "change": _vm.bindStatus
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部状态",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未操作",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已通过",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未通过",
      "value": "3"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "addBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openAddDialog
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "data": _vm.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "index",
      "label": "序号",
      "width": "80px;"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "图像"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "el-table-img",
          attrs: {
            "src": "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
            "alt": ""
          },
          on: {
            "click": function($event) {
              return _vm.openImgDialog(
                'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
              )
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appealTime",
      "label": "同类型排序"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appealTime",
      "label": "目前使用量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appealTime",
      "label": "涉及学生"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appealTime",
      "label": "最新操作"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.status == '1') ? _c('span', [_vm._v("已发布")]) : _vm._e(), _vm._v(" "), (_vm.row.status == '2') ? _c('span', [_vm._v("未发布")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == '1') ? _c('el-button', {
          staticClass: "option",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editItem(scope.row)
            }
          }
        }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (scope.row.status == '1') ? _c('el-button', {
          staticClass: "option",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.publishItem(scope.row)
            }
          }
        }, [_vm._v("发布")]) : _vm._e(), _vm._v(" "), (scope.row.status == '1') ? _c('el-button', {
          staticClass: "option",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.deleteItem(scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (scope.row.status == '2') ? _c('el-button', {
          staticClass: "option",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.openDetail(scope.row)
            }
          }
        }, [_vm._v("详情")]) : _vm._e(), _vm._v(" "), (scope.row.status == '2') ? _c('el-button', {
          staticClass: "option",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.cancelItem(scope.row)
            }
          }
        }, [_vm._v("撤销")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.totalCount > 0),
      expression: "this.totalCount > 0"
    }],
    attrs: {
      "layout": "prev, pager, next, jumper",
      "page-size": 20,
      "current-page": _vm.currentPage,
      "total": _vm.totalCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), (_vm.dialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": _vm.edit ? '编辑个性化组件' : _vm.read ? '查看个性化组件' : '新增个性化组件',
      "modal-append-to-body": false,
      "before-close": _vm.closeDialog
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "disabled": _vm.disable,
      "model": _vm.form,
      "id": "addForm"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "序号",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入序号"
    },
    model: {
      value: (_vm.totalCount),
      callback: function($$v) {
        _vm.totalCount = $$v
      },
      expression: "totalCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": "请输入高校名称"
    },
    model: {
      value: (_vm.totalCount),
      callback: function($$v) {
        _vm.totalCount = $$v
      },
      expression: "totalCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图像",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入高校名称"
    },
    model: {
      value: (_vm.totalCount),
      callback: function($$v) {
        _vm.totalCount = $$v
      },
      expression: "totalCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "同类型排序",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入高校名称"
    },
    model: {
      value: (_vm.totalCount),
      callback: function($$v) {
        _vm.totalCount = $$v
      },
      expression: "totalCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "目前使用量",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入高校名称"
    },
    model: {
      value: (_vm.totalCount),
      callback: function($$v) {
        _vm.totalCount = $$v
      },
      expression: "totalCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "涉及学生",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入高校名称"
    },
    model: {
      value: (_vm.totalCount),
      callback: function($$v) {
        _vm.totalCount = $$v
      },
      expression: "totalCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "最新操作",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入高校名称"
    },
    model: {
      value: (_vm.totalCount),
      callback: function($$v) {
        _vm.totalCount = $$v
      },
      expression: "totalCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入高校名称"
    },
    model: {
      value: (_vm.totalCount),
      callback: function($$v) {
        _vm.totalCount = $$v
      },
      expression: "totalCount"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addcampus
    }
  }, [_vm._v("确 定")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dialogImgVisible) ? _c('el-dialog', {
    attrs: {
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.dialogImgVisible),
      callback: function($$v) {
        _vm.dialogImgVisible = $$v
      },
      expression: "dialogImgVisible"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.dialogImg,
      "alt": ""
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d472616!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/userM/specific.vue
// module id = 1090
// module chunks = 0